import React, { useCallback, useEffect } from "react";
import { logger } from "@mwt/web-js-telemetry";

import { useAuthContext } from "../auth-provider";
import {
  useStoreEpicAudioVideoTestResultsMutation,
  StoreEpicAudioVideoTestResultsMutation,
} from "../../graphql/graphql";
import { useDeviceTesterStateContext } from "../device-tester-context-provider/DeviceTesterContextProvider";
import { epicResultsPayload } from "../../utils/epicResultsPayload";
import { usePlatformTypeContext } from "../platform-type-provider/PlatformTypeProvider";
import { finishLoggingAppSession } from "../telemetry/utils/trackAppSession";

import {
  logTestResultsSentToEpic,
  logSendResultsMutationResponse,
} from "./ConnectedTestCompleted.telemetry";
import { TestCompleted } from "./TestCompleted";

export const ConnectedTestCompleted: React.FC = () => {
  const { isAuthSession, sessionId } = useAuthContext();
  const { deviceTesterState } = useDeviceTesterStateContext();
  const { isMobile, browser, browserVersion, os, osVersion } =
    usePlatformTypeContext();
  const [StoreEpicAudioVideoTestResultsMutation, { data, loading, error }] =
    useStoreEpicAudioVideoTestResultsMutation({
      variables: epicResultsPayload(
        deviceTesterState,
        isMobile,
        sessionId,
        browser,
        browserVersion,
        os,
        osVersion
      ),
    });

  const sendResultsToEpic = useCallback(async () => {
    //log user clicked button to send test results to epic
    logTestResultsSentToEpic();

    const storeAudioVideoTestResultMutationResponse =
      await StoreEpicAudioVideoTestResultsMutation().catch((error: Error) => {
        logger.error(
          `Error in StoreEpicAudioVideoTestResultsMutation, ${error.message}`
        );
      });

    if (storeAudioVideoTestResultMutationResponse) {
      const sendResponseData:
        | StoreEpicAudioVideoTestResultsMutation
        | null
        | undefined = storeAudioVideoTestResultMutationResponse.data;

      logSendResultsMutationResponse(
        sendResponseData?.storeEpicAudioVideoTestResults
      );
    }
  }, [StoreEpicAudioVideoTestResultsMutation]);

  useEffect(() => {
    finishLoggingAppSession();
  }, []);

  return (
    <TestCompleted isAuthFlow={isAuthSession} sendResults={sendResultsToEpic} />
  );
};
